<template>
    <p>this is the form management table component</p>

    <v-row class="ma-0">
        <v-col cols="12" md="6" class="flex-1-1-0">
            <v-autocomplete 
                v-model="filters.states" 
                variant="outlined" 
                autocomplete="off" 
                :items="resolvedStatusList" 
                label="Estado do Pedido"
                multiple
                :disabled="resolvedIsFetchingStatusesList"
                :loading="resolvedIsFetchingStatusesList"
            />
        </v-col>
        <v-col cols="12" md="6" class="flex-1-1-0">
            <v-autocomplete 
                v-model="filters.user_ids" 
                variant="outlined" 
                autocomplete="off" 
                :items="resolvedUsersList" 
                label="Colaborador(a)"
                multiple
                :item-title="(item) => `${item?.worker_code || 'Sem código'} - ${item?.name || 'Sem nome'}`"
                :disabled="resolvedIsFetchingUsersList"
                :loading="resolvedIsFetchingUsersList"
            />
        </v-col>
    </v-row>
    <v-row class="mx-0 my-2">
        <v-col cols="12" class="d-flex justify-end">
            <v-btn 
                prepend-icon="mdi-plus" 
                color="primary" 
                variant="outlined" 
                class="text-none"
                @click="() => console.log(`I want to create a new form!`)"
            >Novo Formulário</v-btn>
        </v-col>
    </v-row>
    <v-data-table-server
        :items="formsList"
        :headers="tableHeaders"
        hide-default-footer
    >

    </v-data-table-server>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';


const props = defineProps({
    formType: {
        type: String,
        default: null,
    },
    usersList: {
        type: Array,
        default: () => {[]},
    },
    isFetchingUsersList: {
        type: Boolean,
        default: false,
    },
    statusesList: {
        type: Array,
        default: () => {[]},
    },
    isFetchingStatusesList: {
        type: Boolean,
        default: false,
    },
});

const tableHeaders = [
    {title: "Título", key: "title", sortable: true, align: "center"},
    {title: "Código", key: "form_code", sortable: true, align:"center"},
    {title: "Versão", key: "version", sortable: true, align: "end"},
    {title: "Ações", keys: "actions", sortable: false, align: "end"},
]

const filters = ref({
    states: null,
    user_ids: null,
});

const localUsersList = ref([]);
const localIsFetchingUsersList = ref(false);

const localStatuesList = ref([]);
const localIsFetchingStatusesList = ref(false);

const formsList = ref([]);

const resolvedIsFetchingUsersList = computed(() => {
    return props?.isFetchingUsersList
            || localIsFetchingUsersList.value
            ;
});

const resolvedUsersList = computed(() => {
    return (
            props?.usersList?.length > 0
            || props?.isFetchingUsersList
        ) 
        ? props.usersList
        : localUsersList.value
    ;
})

const resolvedIsFetchingStatusesList = computed(() => {
    return props.isFetchingStatusesList
            || localIsFetchingStatusesList.value
            ;
});

const resolvedStatusList = computed(() => {
    return (
            props?.statusesList?.length > 0
            || props?.isFetchingStatusesList
        ) 
        ? props.statusesList
        : localStatuesList.value
    ;
})


async function fetchUsersList() {
    if(resolvedIsFetchingUsersList.value) {
        return;
    }
}

async function fetchStatusesList() {
    if(resolvedIsFetchingStatusesList.value) {
        return;
    }
}

onMounted(() => {
    fetchUsersList();
    fetchStatusesList();
})
</script>